var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuNavigationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Navigation_icon",
    "data-name": "Menu Navigation icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.623,
    height: 16.821,
    viewBox: "0 0 26.623 16.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M324.79,451.063h22.26c.3,0,.6,0,.9,0h.038a1.763,1.763,0,0,0,1.208-.5,1.709,1.709,0,0,0,0-2.417,1.775,1.775,0,0,0-1.208-.5h-22.26c-.3,0-.6,0-.9,0h-.038a1.763,1.763,0,0,0-1.208.5,1.709,1.709,0,0,0,0,2.417,1.775,1.775,0,0,0,1.208.5Z",
    transform: "translate(-323.08 -447.644)",
    fill: "#3c3c3b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068",
    transform: "translate(0 6.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M324.79,686.383h22.26c.3,0,.6,0,.9,0h.038a1.763,1.763,0,0,0,1.208-.5,1.709,1.709,0,0,0,0-2.417,1.775,1.775,0,0,0-1.208-.5h-22.26c-.3,0-.6,0-.9,0h-.038a1.763,1.763,0,0,0-1.208.5,1.709,1.709,0,0,0,0,2.417,1.776,1.776,0,0,0,1.208.5Z",
    transform: "translate(-323.08 -682.964)",
    fill: "#3c3c3b"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070",
    transform: "translate(0 13.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M324.79,921.7h22.26c.3,0,.6,0,.9,0h.038a1.763,1.763,0,0,0,1.208-.5,1.709,1.709,0,0,0,0-2.417,1.775,1.775,0,0,0-1.208-.5h-22.26c-.3,0-.6,0-.9,0h-.038a1.763,1.763,0,0,0-1.208.5,1.709,1.709,0,0,0,0,2.417,1.776,1.776,0,0,0,1.208.5Z",
    transform: "translate(-323.08 -918.284)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNavigationicon);
export default __webpack_public_path__ + "static/media/Menu Navigation icon.686089a58aa7cfe4d0beee22ec9d1571.svg";
export { ForwardRef as ReactComponent };